export function calculateAge(birthDate) {
  if (!birthDate) {
    return birthDate;
  }

  const birth = new Date(birthDate);
  const today = new Date();

  let age = today.getFullYear() - birth.getFullYear();
  const monthDiff = today.getMonth() - birth.getMonth();
  const dayDiff = today.getDate() - birth.getDate();

  // Adjust age if birth date hasn't occurred yet this year
  if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
    age--;
  }

  return age;
}

export function calculateDaysActive(createdAt, referenceDate = new Date()) {
  if (!createdAt) return null;

  const createdDate = new Date(createdAt);
  const referenceTime = referenceDate.getTime();

  if (
    Number.isNaN(createdDate.getTime()) ||
    Number.isNaN(referenceTime)
  ) {
    return null;
  }

  const createdDay = Date.UTC(
    createdDate.getFullYear(),
    createdDate.getMonth(),
    createdDate.getDate(),
  );
  const referenceDay = Date.UTC(
    referenceDate.getFullYear(),
    referenceDate.getMonth(),
    referenceDate.getDate(),
  );

  return Math.max(0, Math.floor((referenceDay - createdDay) / 86400000));
}

export const getAge = (dob) => {
  const birthDate = new Date(dob);
  const today = new Date();
  const age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  return m < 0 || (m === 0 && today.getDate() < birthDate.getDate())
    ? age - 1
    : age;
};

export const selectStyles = {
  control: (provided) => ({
    ...provided,
    backgroundColor: "#F4F4F4",
    borderRadius: "8px",
    border: "1px solid #e2e8f0",
    minHeight: "44px",
    boxShadow: "none",
    cursor: "pointer",
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: "#ffffff",
    border: "1px solid #d6c1a8",
    borderRadius: "999px",
    padding: "2px 6px",
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: "#4b5563",
    fontSize: "0.85rem",
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: "#a16207",
    cursor: "pointer",
    ":hover": {
      backgroundColor: "#fde68a",
      color: "#78350f",
    },
  }),
};

export const customStyles = {
  control: (base) => ({
    ...base,
    width: "100%",
    padding: "2px 2px", // react-select already has internal padding
    fontSize: "15px",
    border: "1px solid #ccc",
    borderRadius: "6px",
    boxSizing: "border-box",
    background: "#f4f4f4",
    outline: "none",
    minHeight: "40px", // close to native <select>
    boxShadow: "none",
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "0 8px",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: "0 8px",
  }),
  menu: (base) => ({
    ...base,
    borderRadius: "6px",
    marginTop: 2,
  }),
};

export const customStylesbusiness = {
  control: (base) => ({
    ...base,
    width: "100%",
    fontSize: "14px",
    border: "1px solid #ccc",
    borderRadius: "6px",
    background: "#f4f4f4",
    minHeight: "41px",
    height: "41px",
    boxShadow: "none",
  }),

  valueContainer: (base) => ({
    ...base,
    display: "flex",
    flexWrap: "nowrap", // ✅ STOP wrapping
    overflowX: "auto", // ✅ Horizontal scroll
    scrollbarWidth: "thin",
    whiteSpace: "nowrap",
    height: "41px",
    alignItems: "center",
  }),

  multiValue: (base) => ({
    ...base,
    flexShrink: 0, // ✅ Prevent shrinking
    backgroundColor: "#f1f5f9",
  }),

  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0,
    minWidth: 60,
  }),

  indicatorsContainer: (base) => ({
    ...base,
    height: "41px",
  }),

  dropdownIndicator: (base) => ({
    ...base,
    padding: "0 8px",
  }),

  menu: (base) => ({
    ...base,
    borderRadius: "6px",
    marginTop: 2,
  }),

  option: (base) => ({
    ...base,
    backgroundColor: "white",
    color: "#333",
    ":hover": {
      backgroundColor: "#f3f4f6",
    },
  }),

  menuList: (base) => ({
    ...base,
    padding: 0,
  }),

  multiValueLabel: (base) => ({
    ...base,
    color: "#333",
  }),

  multiValueRemove: (base) => ({
    ...base,
    ":hover": {
      backgroundColor: "#e5e7eb",
      color: "#111",
    },
  }),
};


export const getDefaultProfileIcon = (user) => {
   
  return user?.Gender === 1
    ? require("../assests/images/MaleDefaultIcon.png")
    : require("../assests/images/FeMaleDefaultIcon.png");
};


export const RatingStars = ({ rating = 0 }) => {
  const numericRating = Number(rating) || 0;

  if (numericRating <= 0) return null;

  const getStarFill = (starIndex) => {
    const diff = numericRating - (starIndex - 1);

    if (diff >= 1) return 100;
    if (diff <= 0) return 0;

    return diff * 100;
  };

  return (
    <div
      style={{
        display: "flex",
        gap: 2,
        alignItems: "center",
      }}
    >
      {[1, 2, 3, 4, 5].map((starIndex) => (
        <span
          key={starIndex}
          style={{
            position: "relative",
            width: 16,
            height: 16,
            display: "inline-block",
          }}
        >
          {/* Empty */}
          <span
            style={{
              position: "absolute",
              inset: 0,
              color: "#d0d0d0",
              fontSize: 16,
              lineHeight: "16px",
            }}
          >
            ★
          </span>

          {/* Filled */}
          <span
            style={{
              position: "absolute",
              inset: 0,
              width: `${getStarFill(starIndex)}%`,
              overflow: "hidden",
              color: "#f5b301",
              whiteSpace: "nowrap",
              fontSize: 16,
              lineHeight: "16px",
            }}
          >
            ★
          </span>
        </span>
      ))}
    </div>
  );
};

export const getPhoneCountryOptions = (countries = []) =>
  countries.flatMap((country) => {
    const rawPhoneCode = String(country?.phonecode || "")
      .split(/\s+and\s+/i)[0]
      .split("-")[0];
    const phoneCode = rawPhoneCode.replace(/\D/g, "");

    if (!country?.isoCode || !country?.name || !phoneCode) {
      return [];
    }

    return [
      {
        id: country.isoCode,
        isoCode: country.isoCode,
        value: phoneCode,
        label: `${country.name} (+${phoneCode})`,
        name: country.name,
      },
    ];
  });